var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsBoolean, IsIn, IsString, Matches, MaxLength, MinLength } from 'class-validator';
import { ProfileDefaultViewTypeValues } from './profile-default-view-type';
export class ProfilePreferences {
}
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], ProfilePreferences.prototype, "isPublic", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], ProfilePreferences.prototype, "isIndexable", void 0);
__decorate([
    IsString(),
    MinLength(2),
    MaxLength(100),
    Matches(/^[a-z0-9_-]*$/),
    __metadata("design:type", String)
], ProfilePreferences.prototype, "slug", void 0);
__decorate([
    IsString(),
    IsIn(ProfileDefaultViewTypeValues),
    __metadata("design:type", String)
], ProfilePreferences.prototype, "defaultView", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], ProfilePreferences.prototype, "isEmailVisible", void 0);
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], ProfilePreferences.prototype, "isPhoneNumberVisible", void 0);
//# sourceMappingURL=profile-preferences.js.map